<template>
  <div id="ScannedNotes" >
    <div class="pet-note-area">

      <div class="note-card">
        <div class="note-card-header">
          <div class="h3-text">About {{pet_data.name}}</div>
        </div>
        <div class="note-card-body" >

            <!-- <div class="backlines" :style="{'background-image': 'url(' + require('@/assets/icons/lines.svg') + ')'}">
              <div class="line" v-for="k in 5" :key="k"></div>
            </div> -->

          <div class="no-note-box" v-if="pet_notes == ''">
            <div class="pic-upload"
              :style="{'background-image': 'url(' + require('@/assets/icons/no-note.svg') + ')'}">
            </div>
            <p class="gallery-text">{{randomNoteText}}</p>
          </div>

          <div class="note-present" v-else>
            <p>{{pet_notes}}</p>
          </div>
        </div>
      </div>

      <br />
    </div>
  </div>
</template>
<script>
export default{
  name: 'ScannedNotes',
  props:['pet_notes', 'pet_data'],
  data(){
    return{
      // pet_banner: 'https://images.unsplash.com/photo-1586326709898-0a344840a314?ixlib=rb-1.2.1&auto=format&fit=crop&w=1950&q=80',
      show_Bedit: true,
    }
  },
  computed:{
    randomNoteText(){
      const cleaver_text = [
        'This pet doesn\'t have any thing to say.',
        'There\'s no information about me!'
      ]
      let item = cleaver_text[Math.floor(Math.random() * cleaver_text.length)];
      return item
    },
  },
  methods:{
    enlargeImg(val){
      this.$emit('enlargeImg', val)
    }
  }
}
</script>
<style scoped>
#ScannedNotes{
  width: 80%;
  margin: auto;
}
.note-card{
  width: 90%;
  min-height: 35vh;
  border-radius: 20px;
  box-shadow: 0 10px 10px rgba(0, 0, 0, 0.2);
  background-color: #fff;
}
.note-card-header{
	background-color: var(--primary);
  color: #fff;
  width: 100;
  border-radius: 20px 20px 0 0;
  border-bottom: 1px solid #aeaeae;
}

.note-card-body{
  font-size: 1.1rem;
  position: relative;
  overflow-y:auto;
  overflow-x:hidden;
  height: 100%;
  min-height: 25rem;
  padding: 1rem  2rem;
  min-width: 250px;
}
/* .note-card-body {
  position: relative;
  padding-top: 40px;
  padding-bottom: 40px;
  height: 100%;
  background-image: repeating-linear-gradient(white 0px, white 24px, teal 25px);
  margin: auto 3rem;
}
.note-card-body::before {
  position: absolute;
  top: 0;
  left: 40px;
}
.note-present{
  padding-top: 6px;
 padding-left: 16px;
 padding-right: 16px;
 line-height: 25px;
 font-family: 'Dancing Script', cursive;
 font-size: 19px;
 letter-spacing: 1px;
 word-spacing: 5px;

} */
.no-note-box{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items:center;

}
.no-note-box img{
  width: 6rem;
  transition: 1s;
  margin: 2rem auto;
}

.pic-upload{
  position: relative;
  border: 4px solid #222;
  border-radius: 100%;
  width: 6rem;
  height: 6rem;
  margin: 3rem auto;
  text-align:center;
  overflow:hidden;
  background-position: center;
  background-repeat: no-repeat;
  background-size: 70%;
}
.gallery-text{
  text-align:center;
  color: #777;
  font-weight: bold;
  font-size: 1.3rem;
}
.pic-upload:hover img{
  transform: translateY(-6px);
}
.pet-note-area{
  min-height:20rem;
  padding: 0;
  margin: 2rem auto;
}
.head-text{
  font-size: 1rem;
}
.pet-notes{
  width: 80%;
  margin: .5rem auto;
}
/* NOTE CARD */
.h3-text{
  opacity: 0.6;
  font-weight: bold;
  font-size: 1.1rem;
  margin: .8rem auto;
  letter-spacing: 1px;
  text-transform: uppercase;
}
.h3-text{
  padding: 1rem;
  padding-top: 2rem;
}
@media only screen and (max-width: 600px) {
  .note-card{
    width: 100%;
  }
  .h3-text{
    font-size: .9rem;
  }
}
</style>
